<template>
  <NavComponents />
  
  <div class="container">
    <CarouselComponent/>
      <h6 class="course" style="font-weight: bold; font-size:xx-large;">全部课程
        <span class="titleStyle">AllCourse</span>
      </h6>
    <CateDrawerComponents  @selectCate='selectCate'/>

    <el-button icon="Search" style="float: right; margin: 5px;" @click="searchCourse()" circle />

    <input
      class="input-field"
      type="search"
      placeholder="关键词"
      id="courseName"
      style="float: right;"
    />
    
    <SelectCourseComponents ref="changeCate"/>
   
  </div>
  <NavFooter/>
</template>
  
  <script setup>
import NavComponents from "@/components/nav/NavComponents.vue";
import CateDrawerComponents from "@/components/cate/CateDrawerComponents.vue";
import SelectCourseComponents from '@/components/course/SelectCourseComponents';
import CarouselComponent from '@/components/data/CarouselComponent.vue'
import NavFooter from '@/components/nav/NavFooter.vue'
import { useRoute } from "vue-router";
import { ref } from 'vue';
import $ from 'jquery';

let current_courseName = ref('');
let current_cateId = ref(0);
let changeCate = ref(null);
const Route = useRoute(); //获取到值


const selectCate = (id) => {
  current_cateId = parseInt(id) || 0;
  current_courseName = Route.params.courseName || '';
  changeCate.value.getAllCourse(0, 1, current_cateId, current_courseName);
  changeCate.value.getAllCourse(1, 1, current_cateId, current_courseName);
}

const searchCourse = () => {
  let courseName = $("#courseName").val();
  current_cateId = parseInt(Route.params.cateId) || 0;
  changeCate.value.getAllCourse(0, 1, current_cateId, courseName);
  changeCate.value.getAllCourse(1, 1, current_cateId, courseName);
}

</script>

  <style scoped>

.input-field {
    width: 300px; /* 输入框宽度 */
    padding: 5px;
    border: 1px solid #ccc; /* 边框样式 */
    border-radius: 5px; /* 边框圆角 */
    font-size: 16px; /* 字体大小 */
    outline: none; /* 去除默认轮廓 */
}
.input-field:hover,
.input-field:focus {
    border-color: #66afe9; /* 修改边框颜色 */
    box-shadow: 0 0 5px rgba(102, 175, 233, 0.6); /* 添加阴影效果 */
}

.titleStyle{
  font-size: smaller; 
  color: rgb(113, 20, 219);
  text-decoration: underline;
text-decoration-color: rgb(255, 140, 8);
}

.course {
  margin-top: 80px;
}
</style>